module.exports = __webpack_public_path__ + "static/media/krx-public-04.fc3caaa0.jpg";